import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPromotionRoutePath } from '@intigral/utils/lib/helpers/promotion';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { appConfig } from '../../../config/app.config';
import h from '../../../helpers/common';
import user from '../../../helpers/user';
import useCatchupDetailOverlay from '../../../hooks/useCatchupDetailOverlay';
import useDetailOverlay from '../../../hooks/useDetailOverlay';
import useToggleDetailOverlay from '../../../hooks/useToggleDetailOverlay';
import usePPVManagement from '../../../hooks/usePPVManagement';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { showUpgradedModal } from '../../../store/reducers/generalConfigurationSlice';
import { PromotionItem } from '../types/VerticalBlock.types';
import { sendMixpanelClickEvent } from '../utils/track';
import { showGuestPromotionPopup } from '../../../guest';
import url from '../../../helpers/url';

export const useVerticalBlockHandlers = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { track } = useContext(MixpanelContext);
    const openDetailOverlay = useDetailOverlay();
    const { showPpvOverlay } = useToggleDetailOverlay();
    const { openCatchupDetailOverlay } = useCatchupDetailOverlay();
    const { shouldShowLock } = usePPVManagement();
    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;

    const isItemLocked = (item: PromotionItem) => {
        const channelId = item?.properties?.[0]?.channelId;
        const { isLocked } = shouldShowLock(item, channelId) || {};
        return Boolean(isLocked && enableLockIcon);
    };

    const showUpgradeIfLocked = (item: PromotionItem) => {
        if (isItemLocked(item)) {
            dispatch(showUpgradedModal(true));
            return true;
        }
        return false;
    };

    const handleOpenModal = (item) => {
        openCatchupDetailOverlay({
            channelGuid: item.channelGuid,
            paId: item.paId,
            stationCallSign: item?.channelGuid?.split('_')?.[0] || '',
        });
    };

    const handleItemClick = (item: PromotionItem) => {
        if (showGuestPromotionPopup()) {
            return;
        }
        sendMixpanelClickEvent(track);
        if (item.promoType === 'PPV') {
            showPpvOverlay({
                eventId: item?.ppvEvent?.eventId,
                type: 'Home_Screen',
            });
        } else if (item.promoType === 'CATCHUP') {
            if (showUpgradeIfLocked(item)) return;
            handleOpenModal(item);
        } else if (['SUBSCRIPTION', 'TIER'].includes(item.promoType)) {
            window.location.href = user.getUserProfileUrl();
        } else if (item.promoType === 'ROUTE' && item.screenId) {
            navigate(getPromotionRoutePath(item.screenId, h.getLang(), appConfig.defaultLanguage));
        } else if (item.promoType === 'LIVESTREAM' || item.promoType === 'CHANNEL' || item.promoType === 'REWIND') {
            if (showUpgradeIfLocked(item)) return;
            const liveTvUrl = url.route('livetv', {
                channelId: btoa(item?.properties[0]?.channelId),
            });
            if (url) {
                navigate(liveTvUrl);
            }
            return;
        } else {
            if (showUpgradeIfLocked(item)) return;
            openDetailOverlay(item);
        }
    };

    return { handleItemClick };
};
